import React from "react";
import "../css/others/Popup.css";
import { CopyConfigPopupProps } from "../Interfaces/Interface";
const CopyConfigPopup: React.FC<CopyConfigPopupProps> = ({ isOpen, onClose, onConfirm, sourceSubdomain, targetSubdomain, onSourceChange, clientsList, showSameClientWarning, isConfirmDisabled, }) => {
    if (!isOpen) return null;
    const targetClient = clientsList.find(
        (c) => c.subdomain === targetSubdomain
    );
    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <h2>Copy Configuration</h2>
                <div className="popup-body">
                    <div className="client-selection">
                        <div className="selection-group">
                            <label>Source Client:</label>
                            <select value={sourceSubdomain} onChange={onSourceChange} className="client-select">
                                <option value="">Select Source Client</option>
                                {clientsList
                                    .filter((client) => client.subdomain !== targetSubdomain)
                                    .map((client) => (
                                        <option key={client.subdomain} value={client.subdomain}>{client.clientName}</option>
                                    ))}
                            </select>
                        </div>
                        <div className="selection-group">
                            <label>Target Client:</label>
                            <input type="text" value={targetClient?.clientName || ""} disabled className="client-select" />
                        </div>
                    </div>
                    {showSameClientWarning && (
                        <p className="warning-text">Source and Target clients cannot be the same.</p>
                    )}
                </div>
                <div className="buttonss">
                    <button className="cancel-button" onClick={onClose}>Cancel</button>
                    <button className="submit-button" onClick={onConfirm} disabled={isConfirmDisabled}>Copy Configuration</button>
                </div>
            </div>
        </div>
    );
};
export default CopyConfigPopup;